import styled from "styled-components";

/** Status change history in the new style: one card per change, the old and new status as chips. */
export const StatusHistory = styled.section`
	min-width: 0;
	margin-top: 16px;
	padding-top: 24px;
	border-top: 1px solid #d0d5dd;
	font:
		13px/1.5 "Euclid Circular B",
		sans-serif;
	letter-spacing: 0;
	color: #344054;
	h3 {
		margin: 0 0 10px;
		color: #667085;
		font-size: 11px;
		font-weight: 600;
		letter-spacing: 0.04em;
		text-transform: uppercase;
	}
	.entries {
		display: grid;
		gap: 12px;
	}
	article,
	.empty {
		min-width: 0;
		padding: 18px 20px;
		border: 1px solid #d0d5dd;
		border-radius: 10px;
		background: #fff;
		box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
	}
	.meta {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 4px 12px;
	}
	.author {
		font-weight: 500;
		overflow-wrap: anywhere;
	}
	time {
		font-size: 11px;
		color: #98a2b3;
	}
	.transition {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 12px;
	}
	.status {
		padding: 2px 8px;
		border: 1px solid #d0d5dd;
		border-radius: 6px;
		background: #f9fafb;
		overflow-wrap: anywhere;
	}
	.status[data-status="active"] {
		border-color: #abefc6;
		background: #ecfdf3;
		color: #18774d;
	}
	.status[data-status="blocked"] {
		border-color: #fecdca;
		background: #fef3f2;
		color: #b42318;
	}
	p {
		margin: 12px 0 0;
		white-space: pre-wrap;
		overflow-wrap: anywhere;
	}
	.empty {
		color: #667085;
	}
`;
